import moment from 'moment'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-bootstrap/lib/Modal'
import Button from 'react-bootstrap/lib/Button'
import Grid from 'react-bootstrap/lib/Grid'
import Row from 'react-bootstrap/lib/Row'
import Col from 'react-bootstrap/lib/Col'
import { asyncContainer, Typeahead, Menu, MenuItem } from 'react-bootstrap-typeahead'

import {
  closeBookingInvitationModal,
  fetchSearchInvitee,
  addInvitee,
  removeInvitee,
  setInviteeEmail
} from '../actions/locations.js'

import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import './BookingInvitation.css'

const AsyncTypeahead = asyncContainer(Typeahead)

class BookingInvitation extends Component {
  static defaultProps = {}

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  closeModal() {
    const { dispatch } = this.props
    dispatch(closeBookingInvitationModal())
  }

  onSearchChanged(email) {
    const { dispatch } = this.props

    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (re.test(email)) {
      dispatch(setInviteeEmail(email))
    } else {
      dispatch(setInviteeEmail(undefined))
    }

    let buildingId = ''
    let companyId = ''

    let location = this.props.selectedLocation

    if (location && location.building) {
      buildingId = location.building._id
    }

    if (location && location.company) {
      companyId = location.company._id
    }

    dispatch(fetchSearchInvitee(email, buildingId, companyId))
  }

  onChange(options) {
    const { dispatch } = this.props

    if (options && options.length > 0) {
      if (options[0].email) {
        dispatch(setInviteeEmail(options[0].email))
      }
    }
  }

  addInvitee() {
    let inviteeEmail = this.props.inviteeEmail
    let location = this.props.selectedLocation
    var selectedTimeslot = this.props.selectedTimeslot
    let selectedBooking

    if (location && selectedTimeslot && location.bookings) {
      selectedBooking = location.bookings.find(booking => {
        if (
          moment(booking.startDate).isSameOrBefore(moment(selectedTimeslot.startDate)) &&
          moment(booking.endDate).isSameOrAfter(selectedTimeslot.endDate)
        ) {
          return true
        }
        return false
      })
    }

    if (inviteeEmail && selectedBooking) {
      const { dispatch } = this.props
      dispatch(addInvitee(inviteeEmail, selectedBooking._id))
    }
  }

  removeInvitee(invitee) {
    let location = this.props.selectedLocation
    var selectedTimeslot = this.props.selectedTimeslot
    let selectedBooking

    if (location && selectedTimeslot && location.bookings) {
      selectedBooking = location.bookings.find(booking => {
        if (
          moment(booking.startDate).isSameOrBefore(moment(selectedTimeslot.startDate)) &&
          moment(booking.endDate).isSameOrAfter(selectedTimeslot.endDate)
        ) {
          return true
        }
        return false
      })
    }

    if (invitee.user && selectedBooking) {
      const { dispatch } = this.props
      dispatch(removeInvitee(invitee.user, selectedBooking))
    }
  }

  render() {
    let loading = this.props.loading
    let options = this.props.options
    let inviteeEmail = this.props.inviteeEmail

    let location = this.props.selectedLocation
    var selectedTimeslot = this.props.selectedTimeslot
    let selectedBooking
    let found

    if (location && selectedTimeslot && location.bookings) {
      selectedBooking = location.bookings.find(booking => {
        if (
          moment(booking.startDate).isSameOrBefore(moment(selectedTimeslot.startDate)) &&
          moment(booking.endDate).isSameOrAfter(selectedTimeslot.endDate)
        ) {
          return true
        }
        return false
      })
    }

    if (selectedTimeslot) {
      selectedBooking = location.bookings.find(booking => {
        if (
          moment(booking.startDate).isSameOrBefore(moment(selectedTimeslot.startDate)) &&
          moment(booking.endDate).isSameOrAfter(selectedTimeslot.endDate)
        ) {
          return true
        }
        return false
      })
    }

    /* fucntionalitatea pentru afisarea companiilor
			se efectueaza o filtrare pe toate companiile si se verifica id-ul dompaniei cu id-ul userului */

    if (selectedBooking) {
      let companyAccountId = this.props.account.companies.map(companyId => {
        return companyId._id
      })

      let companyUserId = selectedBooking.user.companies.map(companyId => {
        return companyId._id
      })

      found = companyAccountId.some(r => companyUserId.includes(r))
    }

    return (
      <div style={{ height: 120, width: 200 }}>
        <Modal
          keyboard={false}
          backdrop='static'
          show={this.props.showBookingInvitationModal}
          onHide={this.closeModal.bind(this)}>
          <Modal.Header />
          <Modal.Body>
            <div style={{ width: '100%' }}>
              {(this.props.account.role === 'company_manager' && found) ||
              (selectedBooking && this.props.account._id === selectedBooking.user._id) ? (
                <div style={{ width: '75%', float: 'left' }}>
                  <AsyncTypeahead
                    bsSize='small'
                    isLoading={loading}
                    onSearch={this.onSearchChanged.bind(this)}
                    onChange={this.onChange.bind(this)}
                    options={options}
                    labelKey={option => `${option.fullName}`}
                  />
                </div>
              ) : (
                <div />
              )}

              {(inviteeEmail && (selectedBooking && this.props.account._id === selectedBooking.user._id)) ||
              (this.props.account.role === 'company_manager' &&
                found &&
                this.props.account.role !== 'program_manager' &&
                this.props.account.role !== 'building_manager') ? (
                <Button style={{ width: '20%', float: 'right' }} bsStyle='primary' onClick={this.addInvitee.bind(this)}>
                  {' '}
                  Invite{' '}
                </Button>
              ) : (
                <div style={{ width: '20%', float: 'right' }}>&nbsp;</div>
              )}
            </div>
            <br />
            {selectedBooking && selectedBooking.invitees && selectedBooking.invitees.length > 0 ? (
              <div style={{ width: '100%', float: 'left' }}>
                <Grid fluid={true}>
                  {selectedBooking.invitees.map(invitation => {
                    return (
                      <Row lg={12}>
                        <Col lg={3}>
                          <div class='attendeeCircle' style={{ margin: '10px' }}>
                            <span class='attendeeInitials'>
                              {invitation.user.fullName
                                ? invitation.user.fullName
                                    .split(' ')
                                    .map(n => n[0])
                                    .join('')
                                    .toUpperCase()
                                : invitation.user.invitation}
                            </span>
                          </div>
                        </Col>
                        <Col lg={6}>
                          <div style={{ marginTop: '13px', float: 'left' }}>
                            <h4>{invitation.user.fullName ? invitation.user.fullName : invitation.user.invitation}</h4>
                          </div>
                        </Col>
                        <Col lg={3}>
                          {((this.props.account.role !== 'program_manager' ||
                            this.props.account.role !== 'building_manager') &&
                            this.props.account._id === selectedBooking.user._id) ||
                          this.props.account.role === 'company_manager' ? (
                            <div style={{ float: 'right', marginTop: '20px' }}>
                              <Button bsStyle='danger' onClick={this.removeInvitee.bind(this, invitation)}>
                                Remove
                              </Button>
                            </div>
                          ) : (
                            <div />
                          )}
                        </Col>
                      </Row>
                    )
                  })}
                </Grid>
                <br />
              </div>
            ) : (
              <div class='text-center'>
                <br />
                <h4>No invitees</h4>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle='primary' block onClick={this.closeModal.bind(this)}>
              Ok
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}
const mapStateToProps = state => {
  return { ...state.locationsReducer, account: state.authReducer.account }
}

export default withRouter(connect(mapStateToProps)(BookingInvitation))



// WEBPACK FOOTER //
// ./src/components/BookingInvitation.js